/* eslint-disable @typescript-eslint/no-explicit-any */
const extractor = (prev: any, curr: string) => {
  return prev ? prev[curr] : undefined;
};

export const getProperty = (obj: any, path: string, defaultValue?: any) => {
  const val = path.split('.').reduce(extractor, obj);
  return val === undefined ? defaultValue : val;
};
